import * as React from "react";
import { useCallback } from "react";
import { useInView } from "react-intersection-observer";
import { useGroupContext } from "groopit-js";
import type { GroopItModel_V1 as GroopitModel } from "groopit-js";

declare global {
  interface Window {
    initializeComments: (
      container: HTMLElement,
      scrollContainer: HTMLElement,
      asPostOnly: boolean,
    ) => void;
    createScrollContainer: () => HTMLElement;
  }
}

interface Props {
  groopit: GroopitModel;
  group_id: string;
  can_manage: boolean;
}

export const Comments = (props: Props): JSX.Element => {
  const { groopit, group_id, can_manage } = { ...props };
  const { avatar } = useGroupContext();
  const { ref, inView } = useInView({ threshold: 0, triggerOnce: true });
  const commentEl = useCallback(
    (node) => {
      if (node !== null && inView) {
        window.initializeComments(
          node,
          window.createScrollContainer(),
          groopit.commentCount >= 25,
        );
      }
    },
    [inView],
  );
  return avatar && groopit.canComment ? (
    <div ref={ref} className="comments-minifier">
      <div
        ref={commentEl}
        id={`${groopit.id}-comments-container`}
        className="comments-container feed-comments text-display-subtitle mt-4"
        aria-expanded="false"
        data-avatarurl={avatar}
        data-geturl={`/GroopIt/Comments2/${groopit.id}`}
        data-posturl={`/GroopIt/CommentCreate?groopitId=${groopit.id}`}
        data-puturl="/GroopIt/CommentEdit"
        data-searchurl={`/Groop/SearchUsers/${group_id}`}
        data-canmanage={can_manage}
        data-commentcount={groopit.commentCount}
      ></div>
      <a
        title="Comments"
        role="button"
        data-toggle="comments"
        data-target={`${groopit.id}-comments-container`}
        aria-expanded="false"
        aria-controls={`#${groopit.id}-comments-container`}
      ></a>
    </div>
  ) : (
    <></>
  );
};
